"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.processEntities = void 0;
var _calcShouldDisableEntity = require("./calcShouldDisableEntity");
var _filterEntitiesByExtensions = require("./filterEntitiesByExtensions");
const processEntities = _ref => {
  let {
    entities,
    disabledTooltip,
    forbiddenRootFolderName,
    forbiddenExtensions,
    extensionsToFilter
  } = _ref;
  const filteredEntities = (0, _filterEntitiesByExtensions.filterEntitiesByExtensions)(entities, extensionsToFilter);
  return filteredEntities.map(entity => {
    return (0, _calcShouldDisableEntity.calcShouldDisableEntity)(entity, disabledTooltip, forbiddenRootFolderName, forbiddenExtensions);
  });
};
exports.processEntities = processEntities;
//# sourceMappingURL=processEntities.js.map